import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12 * (props.wx ?? 1)}
    height={32 * (props.hx ?? 1)}
    viewBox="0 0 12 32"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.392 23.591q.19-.692.398-1.226c.242-.617.447-1.245.51-1.905.17-1.766.69-3.991 1.02-6.459.467-3.48.934-7.288 1.807-10.226.476-1.6 1.002-2.849 1.421-2.772.469.087.81 1.707.887 3.85.132 3.598.45 6.481.672 9.113.224 2.663.496 4.318.723 5.702.103.63.33 1.726.818 2.534.623 1.033 1.723 5.625.545 6.993-.65.756-1.404 1.043-2.206 1.4-.5.224-1.369.723-2.255.73-.833.006-1.565-.458-2.342-.791-.776-.332-1.5-.853-1.773-1.258-.837-1.247-.73-3.876-.225-5.685"
    />
  </svg>
);
export default SvgNormal;
